import React, { useState } from 'react';
import cssClasses from './EnterEmailModal.module.css';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../../../Subcomponents/Button';
import DropDown from '../../../../Subcomponents/DropDown';
import CustomInput from '../../../../Subcomponents/CustomInput';

function EnterEmailModal({open, handleClose}) {

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  function submitHandler() {
    const _isEmailValid = isEmailValid(email);
    if (_isEmailValid.flag) {
      handleClose({flag: true, email});
    } else {
      setEmailError(_isEmailValid.helperText);
    }
  }

  return (
    <Modal
      open={open}
      onClose={() => handleClose({flag: false})}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root":{
            background: "rgba(193, 201, 210, 0.7)"
          }
        }
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>Enter Email</h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton className={cssClasses.crossButton} onClick={() => handleClose({flag: false})}> <CloseIcon /> </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <Box className={cssClasses.inputContainer}>
            <CustomInput
              label={"Email"}
              placeholder={"Enter email"}
              inputType='text'
              value={email}
              handleChange={(_value) => {
                setEmail(_value);
                const _isEmailValid = isEmailValid(_value);
                setEmailError(_isEmailValid.helperText);
              }}
              // disabled={}
              helperText={emailError}
            />
          </Box>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff" }} btnName={"Cancel"} clicked={() => handleClose({flag: false})} /></div>
          <div><Button style={{ color: "#ffffff", backgroundColor: "#155EEF" }} btnName={"Submit"} disable={!Boolean(isEmailValid(email).flag)} clicked={() => {submitHandler()}}/></div>
        </div>
      </Box>
    </Modal>
  )
}

export default EnterEmailModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem"
}
function isEmailValid(inputText) {
  let flag = true;
  let helperText = "";
  // eslint-disable-next-line
  var mailFormat =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!inputText || inputText === "") {
    flag = false;
    helperText = "Please Enter email address.";
  } else if (!String(inputText).toLowerCase().match(mailFormat)) {
    flag = false;
    helperText = "Please Enter Valid Email Address.";
  }
  return { flag, helperText };
}